module.exports = __webpack_public_path__ + "media/assets/images/leanbit_home/nosco_slider-7d6fdd2cfc02d812a612b3c20e6cfedd.png";